export const SOUND_URLS = {
  TAP: `${process.env.VUE_APP_SHARE_URL}audio/tap-sound.mp3`,
  RECORDING_START: `${process.env.VUE_APP_SHARE_URL}audio/start-record-sound.mp3`,
};

export default class Sound {
  static audio = null;

  static play(url, options = {}) {
    if (!this.audio) {
      this.audio = new Audio();
    }

    if (!this.audio.paused) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }

    this.audio.src = url;
    this.audio.volume = options.volume || 1;
    this.audio.play();
  }

  static tap() {
    this.play(SOUND_URLS.TAP, {
      volume: 1,
    });
  }

  static record() {
    this.play(SOUND_URLS.RECORDING_START, {
      volume: 0.5,
    });
  }
}